import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { RoomResponse } from 'app/typings/core/admin/rooms/room';
import type { UpdateRoomRequest } from 'app/typings/core/admin/rooms/roomForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type UpdateRoomParams = {
  id: number;
  payload: UpdateRoomRequest;
};

export function useUpdateRoom() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: UpdateRoomParams) =>
      apiMutation(
        'PUT',
        { path: ENDPOINTS.updateRoom, params: { id: id.toString() } },
        payload
      ) as Promise<RoomResponse>,
    onSuccess: (response, variables) => {
      message.success('Room successfully updated');

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.room, { id: variables.id.toString() }],
        response
      );

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.rooms],
      });
    },
    onError: () => {
      message.error('Failed to update room');
    },
  });
}
